import PropTypes from "prop-types";
import {useTheme} from "@emotion/react";
import useBreakpoints from "@util/breakpoints";
import CmsImageLoader from "../../base/CmsImageLoader";

const GenericPageBanner = ({image, children, noGap, localImage}) => {
    const theme = useTheme();

    const bannerCss = useBreakpoints([theme.breakpoint.ns])({
        position: "relative",
        width: '100%',
        minHeight: "45rem",
        paddingTop: ["0", "36%"], // (3:4),  (450px height at 1500px width)
      });
    
      const bannerImg = useBreakpoints([theme.breakpoint.ns])({
        position: ["relative", "absolute"],
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        minHeight: "45rem",
        objectFit: "cover",
        backgroundColor: theme.colors.background.secondary[theme.variant],
    
        "img": {
          width: "100%",
          height: "100%",
          minHeight: "45rem",
          objectFit: "cover",
        },

        "span": {
          position: "absolute",
          left: "0",
          top: "0",
          display: ["none", "block"],
          width: "100%",
          height: "100%",
          backgroundImage: "linear-gradient(to top, rgba(255,255,255,0) 0, rgba(255,255,255,0.7) 0%, rgba(255,255,255, 1%) 33%)",
        }
      });
    
      const bannerCard = useBreakpoints([theme.breakpoint.ns])({
        position: ["relative", "absolute"],
        bottom: ["initial", "3rem"],
        left: ["initial", "0"],
        width: "100%",
    
        "> div": { // kicker
          textTransform: "uppercase",
        },
    
        "h1": { // header
          marginBottom: "0",
          textTransform: ["initial", "uppercase"],
        }
      });

    return (
        <div className={!noGap && "m-gap"} css={bannerCss}>
            <div css={bannerImg}>
                {localImage ? <img src={image} alt="" loading="lazy" /> : <CmsImageLoader url={image} alt=""/>}
                <span></span>
            </div>
            <div data-aos={"fade-up"} className="container pt-3.5 pt-ns-0" css={bannerCard}>
              
                {children}
            </div>
        </div>
    );

}

GenericPageBanner.propTypes = {
    image: PropTypes.string,
    localImage: PropTypes.bool,
    original: PropTypes.bool,
	children: PropTypes.node,
    noGap: PropTypes.bool
};

export default GenericPageBanner